export const getEdokDocumentations = (state) => state.edok.documentations;
